import { format } from 'date-fns'
import { Trans } from 'react-i18next'

interface ThreatenContentProps {
  gracePeriod?: Date
}

export function ThreatenContent({ gracePeriod }: ThreatenContentProps) {
  const formattedDate = gracePeriod ? format(gracePeriod, 'MMMM d, yyyy') : ''
  return (
    <div>
      <p>
        <Trans i18nKey={'components.modals.paymentStatusWarnings.description'} />
      </p>
      {gracePeriod && (
        <p>
          <Trans
            i18nKey={'components.modals.paymentStatusWarnings.alternatively'}
            values={{ dueDate: formattedDate }}
          />
        </p>
      )}
    </div>
  )
}
